export default function Updater(): null {
  // const dispatch = useAppDispatch()
  return null
}
